export const STAR_SPACE_ERROR = {
  message:
    'This space could not be added to Starred Spaces. Refresh and try again.',
};

export const UNSTAR_SPACE_ERROR = {
  message:
    'This space could not be removed from Starred Spaces. Refresh and try again.',
};
